export const APP_INIT_START = 'APP_INIT_START';
export const APP_INIT_SUCCESS = 'APP_INIT_SUCCESS';
export const APP_INIT_FAILURE = 'APP_INIT_FAILURE';

export const APP_LOG = 'APP_LOG';
export const LOG_ACTION = 'LOG_ACTION';
export const LOG_APPSFLYER_ACTION = 'LOG_APPSFLYER_ACTION';

export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';

export const USER_UPDATE_START = 'USER_UPDATE_START';
export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS';
export const USER_UPDATE_FAILURE = 'USER_UPDATE_FAILURE';

export const USER_UPDATE_PASSWORD_START = 'USER_UPDATE_PASSWORD_START';
export const USER_UPDATE_PASSWORD_SUCCESS = 'USER_UPDATE_PASSWORD_SUCCESS';
export const USER_UPDATE_PASSWORD_FAILURE = 'USER_UPDATE_PASSWORD_FAILURE';

export const USER_PROMOCODE_APPLY_START = 'USER_PROMOCODE_APPLY_START';
export const USER_PROMOCODE_APPLY_SUCCESS = 'USER_PROMOCODE_APPLY_SUCCESS';
export const USER_PROMOCODE_APPLY_FAILURE = 'USER_PROMOCODE_APPLY_FAILURE';

export const USER_PROMOCODE_REMOVE_START = 'USER_PROMOCODE_REMOVE_START';
export const USER_PROMOCODE_REMOVE_SUCCESS = 'USER_PROMOCODE_REMOVE_SUCCESS';
export const USER_PROMOCODE_REMOVE_FAILURE = 'USER_PROMOCODE_REMOVE_FAILURE';

export const SET_IS_FIRST_LOGIN = 'SET_IS_FIRST_LOGIN';

export const COMPLETE_ONBOARDING_START = 'COMPLETE_ONBOARDING_START';
export const COMPLETE_ONBOARDING_SUCCESS = 'COMPLETE_ONBOARDING_SUCCESS';
export const COMPLETE_ONBOARDING_FAILURE = 'COMPLETE_ONBOARDING_FAILURE';

export const RESET_FORM_ERROR = 'RESET_FORM_ERROR';

export const UPDATE_AB_TEST_IS_USED_START = 'UPDATE_AB_TEST_IS_USED_START';
export const UPDATE_AB_TEST_IS_USED_SUCCESS = 'UPDATE_AB_TEST_IS_USED_SUCCESS';
export const UPDATE_AB_TEST_IS_USED_FAILURE = 'UPDATE_AB_TEST_IS_USED_FAILURE';

export const LOAD_ACCOUNT_TRADE_INFO_START = 'LOAD_ACCOUNT_TRADE_INFO_START';
export const LOAD_ACCOUNT_TRADE_INFO_SUCCESS = 'LOAD_ACCOUNT_TRADE_INFO_SUCCESS';
export const LOAD_ACCOUNT_TRADE_INFO_FAILURE = 'LOAD_ACCOUNT_TRADE_INFO_FAILURE';

export const SET_RECENT_DONE = 'SET_RECENT_DONE';
export const SET_USER_SELECTED_ACCOUNT_CODE = 'SET_USER_SELECTED_ACCOUNT_CODE';

export const LOAD_ACCOUNT_HISTORY_START = 'LOAD_ACCOUNT_HISTORY_START';
export const LOAD_ACCOUNT_HISTORY_SUCCESS = 'LOAD_ACCOUNT_HISTORY_SUCCESS';
export const LOAD_ACCOUNT_HISTORY_FAILURE = 'LOAD_ACCOUNT_HISTORY_FAILURE';

export const LOAD_ACCOUNT_HISTORY_INFO_START = 'LOAD_ACCOUNT_HISTORY_INFO_START';
export const LOAD_ACCOUNT_HISTORY_INFO_SUCCESS = 'LOAD_ACCOUNT_HISTORY_INFO_SUCCESS';
export const LOAD_ACCOUNT_HISTORY_INFO_FAILURE = 'LOAD_ACCOUNT_HISTORY_INFO_FAILURE';

export const SET_IS_OPEN_MOBILE_APP_BANNER_VISIBLE = 'SET_IS_OPEN_MOBILE_APP_BANNER_VISIBLE';

export const SET_IS_OPEN_RESPAWN_BANNER_VISIBLE = 'SET_IS_OPEN_RESPAWN_BANNER_VISIBLE';

export const BREAKPOINTS = {
    small: 576,
    medium: 768,
    large: 992,
    extraLarge: 1200,
    extraExtraLarge: 1400,
}

export const LOCALE_CODES = {
    pt: 'pt',
    id: 'id',
    en: 'en',
};

export const LINKS = {
    affiliateAgreementDoc: '/docs/affiliate-agreement-fx.pdf',
    amlKycDoc: '/docs/aml-kyc.pdf',
    clientAgreementDoc: '/docs/client-agreement.pdf',
    communicationsPolicyFxDoc: '/docs/communications-policy-fx.pdf',
    privacyPolicyDoc: '/docs/privacy-policy.pdf',
    promotionsDoc: '/docs/promotions.pdf',
    rulesNewLifeDoc: '/docs/respawn.pdf',
}

export const PASSWORD_CHECK_PARAMS = {
    letters: 'letters',
    number: 'number',
};

export const PASSWORD_COMPLEXITY_CHECK_REGEXP = {
    [PASSWORD_CHECK_PARAMS.letters]: '(?=.*[a-zA-Z\u00C0-\u00ff])',
    [PASSWORD_CHECK_PARAMS.number]: '(?=.*[0-9])',
};

export const RouterPaths = {
    app: '/app',
    autoLogin: '/auto-login',
    brokenLink: '/broken-link',
    cashier: '/cashier',
    confirm: '/confirm',
    contacts: '/contacts',
    createdAccounts: '/created-accounts',
    forgot: '/forgot',
    liteTrade: '/lite-trade/:asset?',
    liteTradeChart: '/lite-trade/chart/:asset?',
    liteTradeLogin: '/lite-trade/login',
    liteTradeOrder: '/lite-trade/order',
    liteTradePortfolio: '/lite-trade/portfolio',
    liteTradePosition: '/lite-trade/position',
    liteTradeWatchlist: '/lite-trade/watchlist',
    login: '/login',
    main: '/',
    mainRedesign: '/redesign',
    mobileAppLinks: '/mobile-app-links',
    mobileBonus: '/mobile-bonus',
    mobileDepositBonus: '/mobile-bonus/deposit',
    mobileGift50Bonus: '/mobile-bonus/gift-50',
    mobileInProgress: '/mobile-in-progress',
    onboarding: '/onboarding/:attempt(initial|repeated)',
    onboardingCongratulations: '/onboarding/:attempt(initial|repeated)/congratulations',
    onboardingTutorial: '/onboarding/:attempt(initial|repeated)/tutorial/:step?',
    onboardingWelcome: '/onboarding/initial/welcome',
    partner: '/affiliate',
    partnerApiDocs: '/affiliate/api-docs/:method?',
    partnerCampaigns: '/affiliate/campaigns',
    partnerPayment: '/affiliate/payment',
    partnerPublicDocs: '/docs-affiliate-program',
    partnerStats: '/affiliate/stats',
    partnerSupport: '/affiliate/support',
    privacyPolicy: '/privacy-policy',
    promo: '/promo',
    promotions: '/promotions',
    registration: '/registration',
    reset: '/reset',
    respawn: '/respawn',
    support: '/support',
    trade: '/trade',
    verify: '/verify',
};

export const LOG_EVENT_TYPES = {
    action: 'action',
    exception: 'exception',
    modal: 'modal',
    page: 'page',
    slider: 'slider',
};

export const LOG_AF_EVENT_NAMES = {
    APP_TAB_CLICK: 'app.tab_click',
    CASHIER_PIX_KEY_COPY: 'cashier.pix_key_copy',
    LOGIN_COMPLETED: 'login.completed',
    LOGIN_CONFIRM_PIN: 'login.confirm_pin',
    LOGIN_CREATE_PIN: 'login.create_pin',
    LOGIN_ERROR: 'login.error',
    LOGIN_FINGERPRINT: 'login.fingerprint',
    LOGIN_FINGERPRINT_SHOWN: 'login.fingerprint_shown',
    LOGIN_PIN_SHOWN: 'login.pin_shown',
    LOGIN_SET_FINGERPRINT: 'login.set_fingerprint',
    LOGIN_SHOWN: 'login.shown',
    MAIN_ACCOUNT_ANALYTICS: 'main.account_analytics',
    MAIN_ACCOUNT_OPTIONS: 'main.account_options',
    MAIN_ACCOUNT_TYPE: 'main.account_type',
    MAIN_CHANGE_TIME_FRAME: 'main.change_time_frame',
    MAIN_DEPOSIT: 'main.deposit',
    MAIN_ORDER: 'main.order',
    MAIN_POSITION: 'main.position',
    MAIN_RECOMMENDED_BANNER: 'main.recommended_banner',
    MAIN_RESPAWN: 'main.respawn',
    MAIN_SEARCH: 'main.search',
    MAIN_SELECT_ACCOUNT: 'main.select_account',
    MAIN_SELECT_ASSET: 'main.select_asset',
    MAIN_SHOWN: 'main.shown',
    MAIN_TAB_OPEN: 'main.tab_open',
    MAIN_TRANSACTIONS: 'main.transactions',
    MAIN_WITHDRAW: 'main.withdraw',
    SIGN_UP_ALREADY_HAVE_ACCOUNT: 'sign_up.already_have_account',
    SIGN_UP_COMPLETED: 'sign_up.completed',
    SIGN_UP_EMAIL_IS_CORRECT: 'sign_up.email_is_correct',
    SIGN_UP_EMAIL_IS_CORRECT_CANCEL: 'sign_up.email_is_correct_cancel',
    SIGN_UP_ERROR: 'sign_up.error',
    SIGN_UP_FORM_FILLED: 'sign_up.form_filled',
    SIGN_UP_SHOWN: 'sign_up.shown',
    SIGN_UP_STARTED: 'sign_up.started',
};

export const KEY_CODES = {
    ARROW_UP: 38,
    ARROW_DOWN: 38,
    BACKSPACE: 8,
    ENTER: 13,
};

export const FEATURES = {
    LITE_TRADE: 'lite_trade',
    PROMOCODES: 'promocodes',
    NEW_LIFE: 'new_life',
}

export const ACCOUNT_TYPES = {
    DEMO: 'demo',
    LIVE: 'live',
}

export const URL_SEARCH_PARAMS = {
    ACCEPT_POLICY: 'accept-policy',
    COUNTRY: 'country',
    CODE: 'code',
    EMAIL: 'email',
    INITIAL_AMOUNT: 'initial-amount',
    INITIAL_APPLY_BONUS: 'initial-apply-bonus',
    INITIAL_OPEN_BONUS_TERMS: 'initial-open-bonus-terms',
    PHONE: 'phone',
}

export const CURRENCY_USD = 'USD';
